export function ExtractionLink() {
	return (
		<a
			className="group border-ivory/10 bg-dark-accent text-ivory/50 hover:border-gold/30 hover:text-gold relative z-10 mx-auto flex items-center gap-3 rounded-full border px-6 py-3 text-[10px] tracking-[0.3em] uppercase transition-all"
			href="#"
		>
			Full Extraction
			<span className="bg-gold/30 h-px w-6 transition-all group-hover:w-10" />
			<span className="material-symbols-outlined text-[16px]">
				arrow_forward
			</span>
		</a>
	);
}
